import React from "react";
import Img from "gatsby-image";
import classnames from "classnames";
import Layout from "../layout/Layout";
import Grid from "../grid/Grid";
import Section from "../section/Section";
import cssClass from "./PageLayout.module.scss";

const PageLayout = ({
  name,
  image,
  body,
  alternativeBackground,
  metaDescription,
  url,
}) => {
  const classes = classnames(cssClass.articleHeader, {
    [cssClass.alternativeBackground]: !image && alternativeBackground,
  });

  const seo = {
    title: name,
    description: metaDescription,
    image: image,
    url,
  };

  return (
    <Layout seo={seo}>
      <Section className={classes}>
        <h1>{name}</h1>
      </Section>
      {image && (
        <Img fluid={image.fluid} alt={image.title} className={cssClass.image} />
      )}
      {body && (
        <Section verticalPadding>
          <Grid>
            <div
              dangerouslySetInnerHTML={{
                __html: body.childMarkdownRemark.html,
              }}
              className={cssClass.bodyContent}
            />
          </Grid>
        </Section>
      )}
    </Layout>
  );
};

export default PageLayout;
